// extracted by mini-css-extract-plugin
export var base = "label-module--base--432a4";
export var disabled = "label-module--disabled--96e54";
export var invalid = "label-module--invalid--40e73";